import React from 'react';
import './skill.scss';

class Skill extends React.Component {



  render() {

    const {
        title
      } = this.props;

    return(
      <div className="">
        HEJKA SKILL
      </div>
    )
  }
}

export default Skill;
